/**
 * HCEN product separation — OP and IP/Networks are separate AWS accounts.
 *
 * hospitals.hcen.in      → OP booking + OP admin (HCEN WEBSITE)
 * networks.hcen.in       → Hospital staff HMS login (/login)
 * networks.hcen.in/platform → HCEN Networks platform admin
 *
 * Hospital-level OP↔IP link (owner admin):
 * - Same env HCEN_CROSS_LINK_SECRET on both Lambdas
 * - HMAC pairing codes OP-… / IP-… (no shared DynamoDB)
 * - IP hospital stores opHospitalId; OP hospital stores networksHospitalId
 */
export const PORTALS = {
  OP: {
    id: 'op',
    domain: 'hospitals.hcen.in',
    adminDomain: 'admin.hcen.in',
    label: 'HCEN OP',
    audience: 'Patients + OP booking + OP admin (separate AWS account)',
    touch: false,
  },
  NETWORKS: {
    id: 'networks',
    domain: 'networks.hcen.in',
    label: 'HCEN Networks HMS',
    audience: 'Hospital staff — manager, reception, doctor, billing, IP, pharmacy, lab',
    loginPath: '/login',
  },
  NETWORKS_PLATFORM: {
    id: 'networks-platform',
    domain: 'networks.hcen.in',
    pathPrefix: '/platform',
    label: 'HCEN Networks Platform Admin',
    audience: 'HCEN company owners — add hospitals, plans, modules, Link with OP',
    loginPath: '/platform/login',
  },
};

export const DEFAULT_HOSPITAL_ID = 'HCEN_HOSP26000001';
export const DEFAULT_HOSPITAL_NAME = 'Simha Hospitals';
